import React from "react";
import { Contract } from "../../../../types/contract";
import useContractsTableFields from "../../../../hooks/contracts/table-fields/ContractsTableFieldsHook";
import { TableField } from "../../../../types/table-field";
import TableEntry from "../../common/table/TableEntry";

interface ContractsTableProps {
  tableData: Contract[]
  tableFields: TableField[]
}

const ContractsTableBody: React.FC<ContractsTableProps> = ({ tableData, tableFields }) => {
  const { filterAndFormatContractsByFields } = useContractsTableFields()

  return (
    <>
      {tableData.map((item) => (
        <tr key={item._id} className="bg-cents-grey odd:bg-cents-white hover:bg-cents-purple-lighter h-10 w-full text-sm 2xl:text-base">
          {Object.entries(filterAndFormatContractsByFields(item, tableFields)).map(([key, value]) => (
            <TableEntry key={key} field={key} value={value} destination="contracts" />
          ))}
        </tr>
      ))}
    </>
  )
}

export default ContractsTableBody